<kendo-dialog-titlebar>
    <h4 class="k-m-0" style="color: var(--tb-kendo-neutral-160)">Send Back to IHMS</h4>
</kendo-dialog-titlebar>
@if (loadSpinner) {
<div class="loading-container">
    <kendo-loader type="converging-spinner"></kendo-loader>
</div>
}
<form [formGroup]="form">
    <div class="k-d-grid k-gap-y-5">
        <h5>Action Required: {{actionDetails?.name}}</h5>
        <div class="k-d-grid k-grid-cols-3 k-gap-5">
            <div>
                <span class="font-12">Status</span>
                <p class="k-m-0">{{getStatus(actionDetails?.status)}}</p>
            </div>
            <div>
                <span class="font-12">Action Item ID</span>
                <p class="k-m-0">{{actionDetails?.id}}</p>
            </div>
            <div>
                <span class="font-12">IHMS Case No</span>
                <p class="k-m-0">{{actionDetails?.ihmsCaseNo}}</p>
            </div>
            <div>
                <span class="font-12">Type</span>
                <p class="k-m-0">{{actionDetails?.type}}</p>
            </div>
            <div>
                <span class="font-12">Assignee</span>
                <p class="k-m-0">{{actionDetails?.assigneeName}}</p>
            </div>
            <div>
                <span class="font-12">Due Date</span>
                <p class="k-m-0">{{actionDetails?.dueDate | formatDate}}</p>
            </div>
        </div>
        <div>
            <span class="font-12">Details</span>
            <p class="k-m-0">{{actionDetails?.details}}</p>
        </div>
        <div>
            <kendo-formfield showErrors="initial">
                <kendo-floatinglabel text="Explanation *">
                    <kendo-textarea [rows]="3" placeholder="Type here" formControlName="explanation"></kendo-textarea>
                </kendo-floatinglabel>
                <kendo-formerror>
                    Error: field is required.
                </kendo-formerror>
            </kendo-formfield>
        </div>
    </div>
</form>
<kendo-dialog-actions>
    <button kendoButton themeColor="dark" fillMode="solid" (click)="sendBack()" [disabled]="form.invalid">Send
        Back</button>
</kendo-dialog-actions>